console.log("Version:", process.env.VUE_APP_VERSION, '('+process.env.VUE_APP_GIT_HASH+')', '[',process.env.NODE_ENV.charAt(0).toUpperCase() + process.env.NODE_ENV.slice(1),']')
